import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { registerSW } from 'virtual:pwa-register'
import { App } from './App'
import { AppStoreProvider } from './state/AppStore'
import { AuthProvider } from './auth/AuthProvider'
import { AuthGate } from './screens/AuthGate'
import './styles.css'

// Service workers need a secure context, so this quietly does nothing when the
// iPad loads the dev server over plain http on the LAN. Offline only kicks in
// once the app is served over https or from the home screen.
if ('serviceWorker' in navigator) {
  registerSW({ immediate: true })
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AuthProvider>
      {/* Nothing below this line renders until there is a session: the local
          store, the snapshot fetch and every screen sit behind it. */}
      <AuthGate>
        <AppStoreProvider>
          <App />
        </AppStoreProvider>
      </AuthGate>
    </AuthProvider>
  </StrictMode>,
)
